import React from 'react';
import CardItemDescription from '@/components/cards/CardItemDescription';

const VocabularyMarkdownCard = ({ vocabulary }) => (
  <CardItemDescription value={vocabulary.value} markdown />
);

export default VocabularyMarkdownCard;
